<div class="information-rows astral-stack-m">
  <p class="help-text">{{ 'LEASE_AGREEMENT_INFORMATION_ROW.DESCRIPTION' | translate }}</p>

  <div class="information-rows__toolbar">
    <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_MORE" (click)="createRow()"></astral-button>
    <astral-checkbox [control]="displayForm.controls['displayHistory']"></astral-checkbox>
  </div>

  <app-drag-drop-list-view
    [columnDefinition]="columns"
    [contextMenuDefinition]="menu"
    [itemsSource]="visibleRows"
    [preferencesKey]="'rent.lease-agreement-information-rows.list'"
    [displayRowNumber]="false"
    [displaySummary]="false"
    [previewText]="previewText"
    (itemDropped)="drop($event)"
    (rowClick)="onRowClicked($event)"
  ></app-drag-drop-list-view>
</div>

<ng-template #informationRowSidebar>
  @if (form && selectedRow) {
    <form [formGroup]="form" (ngSubmit)="save()" class="astral-sidebar-shell" novalidate>
      <div class="astral-sidebar-content astral-stack-l">
        <header>
          <h2 class="astral-sidebar-heading">
            {{ (selectedRow.id ? 'LEASE_AGREEMENT_INFORMATION_ROW.EDIT_HEADER' : 'LEASE_AGREEMENT_INFORMATION_ROW.CREATE_HEADER') | translate }}
          </h2>
        </header>
        <div class="astral-form-stack">
          <astral-textarea [control]="form.controls['text']" [maxLength]="200" [rows]="5" [showCharacterCount]="true"></astral-textarea>
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-date-picker [control]="form.controls['fromDate']"></astral-date-picker>
            <astral-date-picker [control]="form.controls['toDate']"></astral-date-picker>
          </astral-layout-group>
        </div>
      </div>
      <footer class="astral-sidebar-footer">
        <astral-button variant="primary" type="submit" labelKey="SAVE_BTN" [disabled]="saving"></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" [disabled]="saving" (click)="closeForm()"></astral-button>
      </footer>
    </form>
  }
</ng-template>
